<template>
  <main>
    <div class="column caption">
      <div
        v-if="localErrors && localErrors.length > 0"
        class="input-group__details errors"
      >
        <div
          v-for="error in localErrors"
          :key="error.error"
          class="input-group__messages"
        >
          <div class="input-group__error error--text">
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import _ from "lodash";

export default {
  name: "Error",
  props: ["error"],
  data() {
    return {
      localErrors: this.error,
    };
  },
  watch: {
    error: {
      handler: function (value) {
        this.prepare(value);
      },
      deep: true,
    },
  },
  created() {
    this.prepare(this.error);
  },
  methods: {
    prepare(value) {
      if (_.isObject(value) && value.items) {
        this.localErrors = this.error.items;
      }

      // check if is an array
      if (_.isArray(value) && !_.isObject(value[0]) && value.lenght != 0) {
        this.localErrors = value;
      }

      // check if is an array of objects
      if (_.isArray(this.localErrors) && _.isObject(this.localErrors[0])) {
        this.localErrors = this.localErrors.map((e) => e.msg);
      }
    },
  },
};
</script>

<style scoped>
.errors {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Error/index.vue